// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"a35c323d","217":"ca59eec5","453":"98ccb609","485":"6fe10d39","952":"c28670b9"}[chunkId] + ".chunk.js";
};